import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight, Lightbulb, Users, Target } from "lucide-react";
import { useTranslation } from "react-i18next";

const AboutPage = () => {
  const { t } = useTranslation("marketing");

  const values = [
    {
      icon: Target,
      title: t("about.value1Title"),
      description: t("about.value1Description"),
    },
    {
      icon: Lightbulb,
      title: t("about.value2Title"),
      description: t("about.value2Description"),
    },
    {
      icon: Users,
      title: t("about.value3Title"),
      description: t("about.value3Description"),
    },
  ];

  return (
    <div>
      {/* Company intro */}
      <section className="container py-16 md:py-24">
        <div className="mx-auto max-w-3xl">
          <h1 className="mb-6 text-center text-4xl font-bold tracking-tight">
            {t("about.title")}
          </h1>
          <div className="space-y-4 leading-relaxed text-muted-foreground">
            <p>
              {/* "4T" company brand stays hardcoded */}
              <strong className="text-foreground">4T</strong>{" "}
              {t("about.intro1")}
            </p>
            <p>{t("about.intro2")}</p>
            <p>
              {/* "Lead Scout" brand stays hardcoded; intro3 starts with the verb */}
              <strong className="text-foreground">Mit </strong>
              <strong className="text-foreground">Lead Scout</strong>{" "}
              {t("about.intro3")}
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="border-t bg-muted/30">
        <div className="container py-16 md:py-24">
          <h2 className="mb-12 text-center text-2xl font-bold tracking-tight">
            {t("about.valuesTitle")}
          </h2>
          <div className="grid gap-8 md:grid-cols-3">
            {values.map((value) => (
              <Card
                key={value.title}
                className="border bg-card shadow-card transition-shadow hover:shadow-md"
              >
                <CardContent className="p-6">
                  <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10">
                    <value.icon className="h-5 w-5 text-primary" />
                  </div>
                  <h3 className="mb-2 text-base font-semibold">
                    {value.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-muted-foreground">
                    {value.description}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="container py-16 text-center md:py-20">
        <h2 className="mb-4 text-2xl font-bold tracking-tight">
          {t("about.ctaTitle")}
        </h2>
        <p className="mb-8 text-muted-foreground">{t("about.ctaSubtitle")}</p>
        <Button asChild size="lg" className="shadow-sm">
          <Link to="/signup">
            {t("about.ctaButton")}
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </section>
    </div>
  );
};

export default AboutPage;
